// @flow
import * as React from 'react';
import type { IconProps } from './IconProps';

const Logo = (props: IconProps) => (
  <svg viewBox="0 0 180.4 174.3" {...props}>
    {' '}
    <metadata id="metadata8">image/svg+xml</metadata>{' '}
    <path
      d="M100.4,99.5h-19.8v34.2h-13.2V53.3c0-3.4,3.2-6.6,6.8-6.6h26.2c17,0,27.9,11.2,27.9,26.4s-10.9,26.4-27.9,26.4ZM99.7,58.6h-19.1v29h19.1c9.2,0,15.4-5.3,15.4-14.4s-6.2-14.6-15.4-14.6Z"
      fill="#fff"
      stroke-width="0"
    />
    <path
      d="M130.1,133.8l-20-28.8s-2.2,1.1-9,1.1h-6.5l19.1,27.8h16.4Z"
      fill="#fff"
      stroke-width="0"
    />
    <path
      d="M22.2,92c0-18.2,5.8-33.9,17.7-47.6l-9.6-8.3c-14,16.2-20.8,34.6-20.8,56,.1,47.1,38.4,85.1,85.4,85v-12.7c-40.1,0-72.6-32.3-72.7-72.3Z"
      fill="#d4e2e1"
      stroke-width="0"
    />
    <path
      d="M166.5,101.7s0,0,0,0c-5,36.1-35.2,62.5-71.6,62.6h0v12.7c42.8-.1,78.4-31.2,84.2-73.6l-12.6-1.7Z"
      fill="#5b9b97"
      stroke-width="0"
    />
    <path
      d="M139.7,19.4l-6.7,10.8s0,0,0,0c24.7,15.4,37.5,42.7,33.6,71.5l12.6,1.7c4.7-33.9-10.4-66-39.4-84Z"
      fill="#6c6cc5"
      stroke-width="0"
    />
    <path
      d="M132.9,30.2l6.7-10.8C117.9,5.9,94.1,2.8,69.6,10.3l3.8,12.2s0,0,0,0c20.8-6.4,41.1-3.8,59.6,7.7Z"
      fill="#afafe3"
      stroke-width="0"
    />
    <path
      d="M73.3,22.5l-3.8-12.2c-16.3,5-28.2,12.8-39.3,25.7l9.6,8.3s0,0,0,0c9.5-11,19.6-17.6,33.5-21.9Z"
      fill="#7edb85"
      stroke-width="0"
    />
  </svg>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Icons/Logo.js